import { jsxs as _jsxs } from "react/jsx-runtime";
import { getRevision } from "../../utils/revision";
export var Revision = function() {
    var _getRevision = getRevision(), appName = _getRevision.appName, appRevision = _getRevision.appRevision;
    return /*#__PURE__*/ _jsxs("div", {
        id: "neru-revision",
        style: {
            display: "none"
        },
        children: [
            appName,
            " ",
            appRevision
        ]
    });
};

//# sourceMappingURL=Revision.js.map